import { combineReducers } from "redux"
import storage from "redux-persist/lib/storage"

import core from "./reducer_core"
import password from "./reducer_password"
import userProfile from "./reducer_user_profile"
import cart from "./reducer_cart"
import myApplication from "./reducer_my_application"
import contactUs from "./reducer_contact_us"
import products from "./reducer_products"
import creditPackages from "./reducer_credit_packages"
import redemptionProducts from "./reducer_redemption_products"
import checkout from "./reducer_checkout"
import treasureBox from "./reducer_treasure_box"
import walletTransactions from "./reducer_wallet_transactions"
import referral from "./reducer_referral"
import luckyDraw from "./reducer_lucky_draw"
import addresses from "./reducer_addresses"
import support from "./reducer_support"

const appReducer = combineReducers({
    core,
    password,
    userProfile,
    cart,
    myApplication,
    contactUs,
    products,
    creditPackages,
    redemptionProducts,
    addresses,
    checkout,
    treasureBox,
    walletTransactions,
    referral,
    luckyDraw,
    support,
})

const rootReducer = (state, action) => {
    if (action.type === "USER_LOGOUT") {
        Object.keys(state).forEach((key) => {
            storage.removeItem(`persist:${key}`)
        })
        state = undefined
    }

    return appReducer(state, action)
}

export default rootReducer
